import $ from "jquery"

// Make jQuery available globally for inline scripts
window.$ = $
window.jQuery = $

// Contact form helpers
window.ContactSubmitButton = function () {
  return document.querySelector("#new_contact_request input[type=submit]")
}

window.EnableContact = function () {
  const btn = window.ContactSubmitButton()
  if (btn) btn.removeAttribute("disabled")
}

window.DisableContact = function () {
  const btn = window.ContactSubmitButton()
  if (btn) btn.setAttribute("disabled", "disabled")
}
